<!-- Header Start -->
<header class="header-hld header-invison">
    <section class="header-bot b5containeradjust">
      <div class="container">
        <div class="row">
          <div class="col-9 ">
                    <a href="javascript:void(0)" title="Sanlam" class="logo-hld"
                        [routerLink]="userData!=null?['/portal/home']:['/register']">
                        <app-logo size="large" width="202" height="43" viewBox="0 0 203 44" fill="none"></app-logo>  
            </a>
          </div>
          <div class="col-3 text-end d-flex justify-content-end">

          </div>
        </div>
      </div>
    </section>
</header>

<!-- Header HTML End -->

<section class="register b5containeradjust">
    <div class="container ">
        <div class="login-hld">
            <div class="d-flex flex-wrap align-items-stretch">
                <div class="col-lg-6 col-md-7 regsterfrm px-3">

                    <div>
                    <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0"><b>Create </b> password</h2>

                    </div>



                    <form class="otp-form forgotfm mt-3" [formGroup]="createPasswordForm" (ngSubmit)="createPassword()">
                        <div class="d-flex">
                            <div class="modal-body">
                                <div *ngIf="errorMsg!=''" class="alert alert-danger" role="alert">
                                    {{errorMsg}}
                                </div>

                                <div *ngIf="successMsg!=''" class="alert alert-success" role="alert">
                                    {{successMsg}}
                                </div>
                                <div *ngIf="isTokenValidate">
                                <div class="form-group fullwidth pwd required remove-ng-dirtycolor">
                                    <div class="form-field">
                                        <input id="Password" [type]="changetype?'password':'text'" class="form-control" placeholder=""
                                            formControlName="Password" [(ngModel)]="password" [closeDelay]="1000"
                                            [ngbPopover]="popContent" popoverTitle="Password Requirements" triggers="click:blur focus">
                                            <span class="eyeicon" (click)="viewpass()"><i><img ngOptimizedImage  [src]="visible?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                            <label for="Password">Password*</label>
                                        <app-password-strength-bar *ngIf="password" [passwordToCheck]="password"
                                            [barLabel]="'Password strength:'" class="psb"></app-password-strength-bar>
                                        <div *ngIf="createPasswordFormControls.Password.touched && createPasswordFormControls.Password.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="createPasswordFormControls.Password.errors.required">Password is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth pwd-confirm align-self-start required remove-ng-dirtycolor">
                                    <div class="form-field">
                                        <input id="ConfirmPassword" [type]="changetypec?'password':'text'" class="form-control" placeholder=""
                                            formControlName="ConfirmPassword">
                                            <span class="eyeicon" (click)="viewpass()"><i><img ngOptimizedImage [src]="visible?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>

                                        <label for="ConfirmPassword">Confirm Password*</label>
                                        <div *ngIf="createPasswordFormControls.ConfirmPassword.touched && createPasswordFormControls.ConfirmPassword.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="createPasswordFormControls.ConfirmPassword.errors.required">Confirm password is
                                                required</div>
                                            <div *ngIf="createPasswordFormControls.ConfirmPassword.errors.mustMatch">Password must match
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="submit"  class="btnregister mb-4" name="btnCreatePasswordPage" id="SubmitCreatePassword">
                                        Submit
                                    </button>
                                </div>
                                <ng-template #popContent>
                                        Be at least 8 characters <br>
                                        Uppercase and lowercase letter (A,z) <br>
                                        Numeric character (0-9) <br>
                                        Special character (!,%,&#64;,#,etc.)
                                </ng-template>
                            </div>



                            </div>
                        </div>

                    </form>
                    <!--mobile Image-->
                    <figure class="m-0 d-block d-md-none">
                        <div class="bgmg position-relative">
                           <img  ngOptimizedImage  src="../../assets/images/registerimg.jpg" class="ps-md-5" alt="" />
                        </div>
                    </figure>
                </div>
                <div
                    class="col-lg-6 col-md-5 d-flex flex-wrap pt-lg-3 ps-lg-5 ps-3 pe-lg-3 pe-3 col-12 boxblue align-items-stretch">
                    <app-need-help></app-need-help>
                </div>
            </div>

        </div>
    </div>
</section>


<!-- Footer HTML Start -->
<app-footer></app-footer>
<!-- Footer HTML End -->








